// @ts-ignore
import { type ApiResult } from "@utils/httpClientCore";
import { gaApiCall } from "@utils/httpClientCsrf";
// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { renderJsonWithNumbersAsBigint, parseJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import type * as schema from "@newgenerated/shared/schema";
import { deserialize_ContextFlagArr } from "@newgenerated/shared/serializerDeserializer/ContextFlagArr";

export async function getContextFlags(): Promise<ApiResult<schema.ContextFlagArr>> {
  const path = "/gaapi/context-flags";
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.ContextFlagArr> => {
    return deserialize_ContextFlagArr(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error", errorCode: null, errorMessage: "deserialize failed" };
  }
  return { kind: "success", data: deserialized.value };
}
